import type {RequestFilter} from './types';
import {authStore} from '../authentication/AuthenticationStore';

/**
 * Request filter for balance_settings API requests that update default payout methods.
 *
 * This filter:
 * 1. Matches POST requests to /v1/balance_settings with default_payout_method_for_currency
 * 2. Overrides the Authorization header to use the external account ephemeral key
 * (used by the external account form).
 *
 * The external account ephemeral key is required for these operations instead of the
 * standard account session key. This pattern is inspired by how we override the auth
 * header for V1 external account requests in `addExternalAccountFilter.ts`.
 */
export const addBalanceSettingsFilter: RequestFilter = {
  matchers: [
    {
      urlPath: /\/v1\/balance_settings/,
      method: 'POST',
      body: /default_payout_method_for_currency/,
    },
  ],

  filterRequest: (requestData) => {
    const selectedApiKeyAndType = authStore.getApiKey('external_account');

    if (!selectedApiKeyAndType) {
      throw new Error('User has not stored external_account key');
    }

    const updatedRequest = {
      ...requestData.request,
      headers: {
        ...requestData.request.headers,
        Authorization: `Bearer ${selectedApiKeyAndType.key}`,
      },
    };

    return {
      ...requestData,
      request: updatedRequest,
    };
  },
};
